import { useTranslation as usePublicI18n } from "react-i18next";
import { publicText, publicTemplate } from "./publicText";
import React from "react";
import { Link } from "react-router-dom";
function PublicFooter() {
  usePublicI18n();
  return <footer className="public-footer">
      <div className="public-footer-inner">
        <div className="public-footer-brand">
          <strong>{publicText("Stomata Scope")}</strong>
          <p>{publicText("Image-based observation and quantification of stomatal responses.")}</p>
        </div>

        <div className="public-footer-columns">
          <div>
            <span>{publicText("STUDIES")}</span>
            <Link to="/case-studies/01">{publicText("Case 01")}</Link>
            <Link to="/case-studies/02">{publicText("Case 02")}</Link>
            <Link to="/case-studies/03">{publicText("Case 03")}</Link>
          </div>
          <div>
            <span>{publicText("SYSTEM")}</span>
            <Link to="/login">{publicText("Login")}</Link>
            <Link to="/terms">{publicText("Terms")}</Link>
          </div>
          <div>
            <span>{publicText("COMPANY")}</span>
            <a href="https://happy-quality.jp/" target="_blank" rel="noreferrer">{publicText("Happy Quality")}</a>
          </div>
        </div>
      </div>

      <div className="public-footer-copy">
        <span>{publicText("\xA9 Happy Quality Co., Ltd.")}</span>
        <span>{publicText("Case-study results are condition-specific and are not product efficacy claims.")}</span>
      </div>
    </footer>;
}
export default PublicFooter;
